var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',{staticClass:"footer-content"},[_c('van-col',{staticClass:"row-content",attrs:{"span":24}},[_vm._v("河姆渡方案馆 msolution.homedo.com")]),_vm._v(" "),_c('van-col',{staticClass:"row-content",attrs:{"span":24}},[_vm._v("上海市浦东新区沪南路4888号2楼 400-807-7117转9")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b0aa189","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 